import React from 'react';
import { useIntl } from 'react-intl';

/**
 * Placeholder component that displays a loading skeleton for the trade list table.
 * @returns {React.ReactElement} - TradeListTablePlaceholder component
 */
function TradeListTablePlaceholder() {
  const intl = useIntl();

  const idLabel = intl.formatMessage({ id: 'trade.trade_list.trade_list_table.placeholder.head.id.label', defaultMessage: 'ID' });
  const timestampLabel = intl.formatMessage({ id: 'trade.trade_list.trade_list_table.placeholder.head.timestamp.label', defaultMessage: 'Timestamp' });
  const detailsLabel = intl.formatMessage({ id: 'trade.trade_list.trade_list_table.placeholder.head.details.label', defaultMessage: 'Details' });
  const directionLabel = intl.formatMessage({ id: 'trade.trade_list.trade_list_table.placeholder.head.direction.label', defaultMessage: 'Direction' });
  const typeLabel = intl.formatMessage({ id: 'trade.trade_list.trade_list_table.placeholder.head.type.label', defaultMessage: 'Type' });
  const tradepointLabel = intl.formatMessage({ id: 'trade.trade_list.trade_list_table.placeholder.head.tradepoint.label', defaultMessage: 'Trade Point' });
  const counterpartyLabel = intl.formatMessage({ id: 'trade.trade_list.trade_list_table.placeholder.head.counterparty.label', defaultMessage: 'Counterparty' });
  const ruleLabel = intl.formatMessage({ id: 'trade.trade_list.trade_list_table.placeholder.head.rule.label', defaultMessage: 'Rule' });
  const totalBuyLabel = intl.formatMessage({ id: 'trade.trade_list.trade_list_table.placeholder.foot.total_buy.label', defaultMessage: 'Total Buy' });
  const totalSellLabel = intl.formatMessage({ id: 'trade.trade_list.trade_list_table.placeholder.foot.total_sell_label', defaultMessage: 'Total Sell' });

  return (
    <div className="mt-4 mb-4 card trades-history-list" aria-hidden="true">
      <div className="table-responsive">
        <table className="table">
          <thead>
            <tr>
              <th scope="col">{idLabel}</th>
              <th scope="col">{timestampLabel}</th>
              <th scope="col">{detailsLabel}</th>
              <th scope="col">{directionLabel}</th>
              <th scope="col">{typeLabel}</th>
              <th scope="col">{tradepointLabel}</th>
              <th scope="col">{counterpartyLabel}</th>
              <th scope="col">{ruleLabel}</th>
            </tr>
          </thead>
          <tbody>
            {[...Array(5)].map((_, index) => (
              <tr key={`placeholder-row-${index + 1}`}>
                <th scope="row" colSpan={2}>
                  <span className="placeholder placeholder-glow bg-darken col-10" />
                  <div style={{ whiteSpace: 'nowrap', fontWeight: 'normal' }}>
                    <span className="placeholder placeholder-glow bg-darken col-6" />
                    <br />
                    <span className="placeholder placeholder-glow bg-darken placeholder-sm col-4" />
                  </div>
                </th>
                <td style={{ whiteSpace: 'nowrap' }}>
                  <span className="placeholder placeholder-glow bg-darken col-8" />
                  <br />
                  <span className="placeholder placeholder-glow bg-darken col-6" />
                  <br />
                  <span className="placeholder placeholder-glow bg-darken col-7" />
                </td>
                <td colSpan={2}>
                  <span className="placeholder placeholder-glow bg-darken placeholder-sm col-5" />
                  <br />
                  <span className="placeholder placeholder-glow bg-darken placeholder-sm col-4" />
                </td>
                <td>
                  <span className="placeholder placeholder-glow bg-darken col-9" />
                  <br />
                  <span className="placeholder placeholder-glow bg-darken col-7" />
                  <br />
                  <span className="placeholder placeholder-glow bg-darken col-8" />
                </td>
                <td>
                  <span className="placeholder placeholder-glow bg-darken col-6" />
                  <br />
                  <span className="placeholder placeholder-glow bg-darken col-8" />
                  <br />
                  <span className="placeholder placeholder-glow bg-darken col-7" />
                  <br />
                  <span className="placeholder placeholder-glow bg-darken placeholder-sm col-5" />
                </td>
                <td>
                  <span className="placeholder placeholder-glow bg-darken col-10" />
                </td>
              </tr>
            ))}
          </tbody>
          <tfoot className="border-top-0">
            <tr>
              <td colSpan={8}>
                <div>
                  <span>
                    <span className="placeholder placeholder-glow bg-darken col-12" />
                  </span>
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row" colSpan={2}>{totalBuyLabel}</th>
              <td colSpan={6}>
                <div>
                  <span className="placeholder placeholder-glow bg-darken col-6" />
                  <br />
                  <span className="placeholder placeholder-glow bg-darken col-5" />
                  <br />
                  <span className="placeholder placeholder-glow bg-darken col-7" />
                </div>
              </td>
            </tr>
            <tr>
              <th className="border-bottom-0" scope="row" colSpan={2}>{totalSellLabel}</th>
              <td className="border-bottom-0" colSpan={6}>
                <div>
                  <span className="placeholder placeholder-glow bg-darken col-6" />
                  <br />
                  <span className="placeholder placeholder-glow bg-darken col-5" />
                  <br />
                  <span className="placeholder placeholder-glow bg-darken col-7" />
                </div>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
      <div className="card-footer">
        <div className="trade-history-pagination">
          <span>
            <span className="placeholder placeholder-glow bg-darken col-1" />
          </span>
        </div>
      </div>
    </div>
  );
}

export default TradeListTablePlaceholder;
